import { landingContent } from "../../data/landingContent";

function renderCell(cell: string, colIndex: number) {
  // Feature name column (leftmost)
  if (colIndex === 0) {
    return <span className="st-comparison-feature-text">{cell}</span>;
  }

  // Stalkie Column (Index 1) - Pink capsule badge
  if (colIndex === 1) {
    return (
      <span className="st-comparison-badge-stalkie">
        {cell}
      </span>
    );
  }

  // Others Column (Index 2) - Red/Coral capsule badge
  return (
    <span className="st-comparison-badge-others">
      {cell}
    </span>
  );
}

export function ComparisonTable() {
  const { comparison } = landingContent;

  return (
    <section className="st-section" style={{ background: "var(--gray-light)" }} aria-label="Stalkie vs Alternatives comparison">
      <div className="st-container" style={{ textAlign: "center", marginBottom: "36px" }}>
        <div className="st-reveal">
          <div className="st-eyebrow" style={{ justifyContent: "center" }}>{comparison.eyebrow}</div>
          <h2 className="st-heading-2">{comparison.title}</h2>
          <p className="st-body-large" style={{ maxWidth: "600px", margin: "10px auto 0" }}>
            {comparison.subtitle}
          </p>
        </div>
      </div>

      <div className="st-container">
        <div className="st-comparison-wrap">
          <div className="st-comparison-grid" role="table">
            <div className="st-comparison-row st-comparison-row-header" role="row">
              {comparison.columns.map((column) => {
                const isStalkie = column === "Stalkie";
                return (
                  <div
                    key={column}
                    className={isStalkie ? "st-comparison-head-stalkie" : "st-comparison-head"}
                    role="columnheader"
                  >
                    {isStalkie ? (
                      <>
                        Stalkie<span>.app</span>
                      </>
                    ) : (
                      column
                    )}
                  </div>
                );
              })}
            </div>

            {comparison.rows.map((row, rowIndex) => (
              <div className="st-comparison-row" key={rowIndex} role="row">
                {row.map((cell, colIndex) => (
                  <div
                    key={colIndex}
                    className={`st-comparison-cell ${
                      colIndex === 0 ? "st-comparison-feature-cell" : ""
                    } ${colIndex === 1 ? "st-comparison-stalkie-cell" : ""}`}
                    role="cell"
                  >
                    {renderCell(cell, colIndex)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
